import * as React from 'react'

import { Icon, IconProps } from './Icon'

export const TemperatureIcon: React.FC<IconProps> = props => (
  <Icon {...props}>
    <path
      d="M12.2 21C10.8167 21 9.6375 20.5125 8.6625 19.5375C7.6875 18.5625 7.2 17.3833 7.2 16C7.2 15.2 7.375 14.4542 7.725 13.7625C8.075 13.0708 8.56666 12.4833 9.2 12V6C9.2 5.16667 9.49166 4.45833 10.075 3.875C10.6583 3.29167 11.3667 3 12.2 3C13.0333 3 13.7417 3.29167 14.325 3.875C14.9083 4.45833 15.2 5.16667 15.2 6V12C15.8333 12.4833 16.325 13.0708 16.675 13.7625C17.025 14.4542 17.2 15.2 17.2 16C17.2 17.3833 16.7125 18.5625 15.7375 19.5375C14.7625 20.5125 13.5833 21 12.2 21ZM9.2 16H15.2C15.2 15.5167 15.0958 15.0667 14.8875 14.65C14.6792 14.2333 14.3833 13.8833 14 13.6L13.2 13V6C13.2 5.71667 13.1042 5.47917 12.9125 5.2875C12.7208 5.09583 12.4833 5 12.2 5C11.9167 5 11.6792 5.09583 11.4875 5.2875C11.2958 5.47917 11.2 5.71667 11.2 6V13L10.4 13.6C10.0167 13.8833 9.72083 14.2333 9.5125 14.65C9.30416 15.0667 9.2 15.5167 9.2 16Z"
      fill="currentColor"
    />
    <path
      d="M20 4C20.5523 4 21 4.44772 21 5C21 5.55228 20.5523 6 20 6H18C17.4477 6 17 5.55228 17 5C17 4.44772 17.4477 4 18 4H20Z"
      fill="currentColor"
    />
    <path
      d="M22 7C22.5523 7 23 7.44772 23 8C23 8.55228 22.5523 9 22 9H18C17.4477 9 17 8.55228 17 8C17 7.44772 17.4477 7 18 7H22Z"
      fill="currentColor"
    />
    <path
      d="M20 10C20.5523 10 21 10.4477 21 11C21 11.5523 20.5523 12 20 12H18C17.4477 12 17 11.5523 17 11C17 10.4477 17.4477 10 18 10H20Z"
      fill="currentColor"
    />
  </Icon>
)
